import graphqlClient from "../../../apollo";

class VendedorProvider {
  findVendedor(id) {
    return graphqlClient.query({
      query: require("./gql/vendedorFind.graphql"),
      variables: { id },
      fetchPolicy: "network-only",
    });
  }

  fetchVendedores() {
    return graphqlClient.query({
      query: require("./gql/vendedorFetch.graphql"),
      fetchPolicy: "network-only",
    });
  }

  paginateVendedores(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
    return graphqlClient.query({
      query: require("./gql/vendedorPaginate.graphql"),
      variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
      fetchPolicy: "network-only",
    });
  }

  createVendedor(input) {
    return graphqlClient.mutate({
      mutation: require("./gql/vendedorCreate.graphql"),
      variables: { input },
    });
  }

  updateVendedor(id, input) {
    return graphqlClient.mutate({
      mutation: require("./gql/vendedorUpdate.graphql"),
      variables: { id, input },
    });
  }

  deleteVendedor(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/vendedorDelete.graphql"),
      variables: { id },
    });
  }
}

export default new VendedorProvider();
